<template>
	<div v-show="isShow" id="Advertisement-wrap">
		<div class="Advertisement-nav">
			<span class="close" @click="isShow = false">×</span>
			<div class="Advertisement-con">
				<a href="#" target="_blank">
					这<br>是<br>一<br>个<br>广<br>告<br>位
					<!-- <img src="//edu-image.nosdn.127.net/EA124290A42485636856F8FC86157028.jpg?imageView&thumbnail=140y260&quality=100" alt=""> -->
				</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name: 'Advertisement',
    data(){
      return {
		isShow: true,
      }
    },
    methods:{
    },
    created(){
    },
  }
</script>

<style>
	#Advertisement-wrap{
		width: 148px;
		position: fixed;
		left: 2px;
		bottom: 60px;
		z-index: 101;
		background-image: linear-gradient(to right,#eaf4fc,#a0d8ef)
	}
	#Advertisement-wrap .Advertisement-nav{
		font-size: 14px;
	}
	#Advertisement-wrap .Advertisement-nav img{
		width: 148px;
	}
	#Advertisement-wrap .close {
	    position: absolute;
	    border: 1px solid #eee;
	    color: #666;
	    background: #fff;
	    border-radius: 10px;
	    right: -5px;
	    top: -5px;
	    width: 22px;
	    height: 22px;
	    text-align: center;
	    font: 15px/24px simsun;
		cursor: pointer;
	}
	#Advertisement-wrap .Advertisement-con{
		height: 200px;
		text-align: center;
	}
</style>
